import { actionButtonObject } from './actionButtonOptions';

export const propertyArrayList = ({ taskList }) => {
	return taskList.map((item) => {
		return {
			lynProperties: item.templatenamePropertyCodes.map((code) => {
				return {
					altCode: code,
					status: 'Active',
					type: item.type.toUpperCase(),
					taskCodeCheck: item?.taskCode,
					displayName: actionButtonObject?.[code]?.label,
					propertyValue: actionButtonObject?.[code]?.value,
				};
			}),
		};
	});
};

// export const buildUpdatedWorkflowArray = ({ existingResponse, taskList }) => {
// 	const payload = propertyArrayList({ taskList });

// 	const existingFlat = existingResponse?.flat() || [];

// 	const finalOutput = payload.map((group) => {
// 		return group.map((newItem) => {
// 			const found = existingFlat.find((old) => old?.altCode === newItem?.altCode && old?.propertyValue === newItem?.propertyValue);

// 			if (found) {
// 				return {
// 					...found,
// 				};
// 			}

// 			return {
// 				...newItem,
// 				id: '',
// 			};
// 		});
// 	});

// 	return finalOutput;
// };

export const buildUpdatedWorkflowArray = ({ existingResponse, taskList }) => {
	const payload = propertyArrayList({ taskList });

	const existingFlat = existingResponse?.flatMap((group) => group.lynProperties) || [];

	const finalOutput = payload.map((group) => {
		const updatedProps = group.lynProperties.map((newItem) => {
			const found = existingFlat.find(
				(old) =>
					old?.altCode === newItem?.altCode &&
					old?.propertyValue === newItem?.propertyValue &&
					old?.propertyCode?.includes(newItem?.taskCodeCheck)
			);

			if (found) {
				return { ...found };
			}

			return { ...newItem, id: null };
		});

		return {
			...group,
			lynProperties: updatedProps,
		};
	});

	return finalOutput;
};

export const conditionPayload = ({ conditionNodeList, conditionMaster }) => {
	const taskConditionPeople = conditionNodeList?.map((item) => ({
		taskActionTaken: item?.data?.taskActionTaken,
		conditionPeopleSet: item?.data?.conditionPeopleSet?.map((conditionSet) => {
			conditionSet.lynApprovalConditions = [
				...(conditionSet.lynApprovalConditions || []),
				{ key: 'action', operation: 'EQUAL', operand: 'SUBMIT' },
			];

			const isSLAEmpty = conditionSet.lynApprovalSLA && Object.values(conditionSet.lynApprovalSLA).every((v) => v === undefined);

			if (isSLAEmpty) {
				conditionSet.lynApprovalSLA = {
					slaCode: null,
					duration: 0,
					unit: null,
					slaId: null,
				};
			}

			return conditionSet;
		}),
	}));

	return {
		...conditionMaster,

		taskConditionPeople,
	};
};
